/* =====================================================================
   MÓDULOS — Plataforma de Gestión y Viabilidad de Proyectos de Inversión
   Cada módulo es un objeto independiente. Edita aquí sin tocar componentes.
   imagen: URL de Unsplash (800×400, temática por grupo)
   url:    Dejar vacío hasta tener el iframe real
   ===================================================================== */

export const modulos = [

  // ─── GRUPO A: Diagnóstico y Territorio ───────────────────────
  {
    id: 1,
    grupo: "A",
    nombre: "Línea Diagnóstica Territorial",
    descripcion: "Plataforma centralizada para la caracterización socioeconómica y ambiental. Facilita el mapeo estratégico de actores y la identificación temprana de variables de conflictividad.",
    puntosClave: ["Mapeo de actores clave", "Análisis de conflictividad", "Perfilamiento territorial"],
    stack: ["Motor de captura dinámica", "Base de datos Cloud", "Tablero de Indicadores"],
    imagen: "https://images.unsplash.com/photo-1508193638397-1c4234db14d8?w=800&q=80&auto=format&fit=crop",
    status: "nuevo",
    url: "",
  },
  {
    id: 2,
    grupo: "A",
    nombre: "Evaluación de Impacto y Líneas Base",
    descripcion: "Herramienta analítica para medir el progreso y cierre de brechas monitoreando KPIs estratégicos de la cadena de valor del DNP.",
    puntosClave: ["Semáforo de indicadores", "Trazabilidad DNP", "Medición de impacto"],
    stack: ["Tablero de Indicadores", "Data Grid Cloud"],
    imagen: "https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=800&q=80&auto=format&fit=crop",
    status: "nuevo",
    url: "",
  },
  {
    id: 3,
    grupo: "A",
    nombre: "Georeferenciación y Visor Territorial",
    descripcion: "Sistema de visualización geoespacial interactivo que cruza capas operativas mediante mapas de calor para focalizar la inversión.",
    puntosClave: ["Mapas de calor interactivos", "Integración de capas oficiales", "Visor de impacto regional"],
    stack: ["Motor GIS", "Analítica Geoespacial"],
    imagen: "https://images.unsplash.com/photo-1526778548025-fa2f459cd5c1?w=800&q=80&auto=format&fit=crop",
    status: "adaptar",
    url: "",
  },
  {
    id: 4,
    grupo: "A",
    nombre: "Análisis de Clúster Productivo",
    descripcion: "Inteligencia de mercados para evaluar el potencial exportador regional, analizando costos operativos y matrices de competitividad.",
    puntosClave: ["Estudio de demanda internacional", "Matriz de competitividad", "Ranking de exportación"],
    stack: ["Motor de captura dinámica", "Base de datos Cloud"],
    imagen: "https://images.unsplash.com/photo-1500382017468-9049fed747ef?w=800&q=80&auto=format&fit=crop",
    status: "nuevo",
    url: "",
  },
  {
    id: 5,
    grupo: "A",
    nombre: "Recolección de Información en Campo",
    descripcion: "Solución digital para la captura de datos en territorio, gestionando fichas de producto y validaciones fitosanitarias en tiempo real.",
    puntosClave: ["Formularios PWA offline", "Validación fitosanitaria", "Consolidación de encuestas"],
    stack: ["Motor de captura dinámica", "Formularios PWA offline"],
    imagen: "https://images.unsplash.com/photo-1464226184884-fa280b87c399?w=800&q=80&auto=format&fit=crop",
    status: "nuevo",
    url: "",
  },

  // ─── GRUPO B: Núcleo Estratégico ─────────────────────────────
  {
    id: 6,
    grupo: "B",
    nombre: "Lineamientos Técnicos Ambientales",
    descripcion: "Gestión de planes de trabajo con CARs y repositorio de estudios técnicos E&P.",
    puntosClave: ["Planes de trabajo por CAR", "Repositorio de estudios E&P", "Semáforo de cumplimiento ambiental"],
    stack: ["Repositorio Cloud Cifrado", "Data Grid Cloud"],
    imagen: "https://images.unsplash.com/photo-1441974231531-c6227db76b6e?w=800&q=80&auto=format&fit=crop",
    status: "adaptar",
    url: "",
  },
  {
    id: 7,
    grupo: "B",
    nombre: "Inversión Social Territorial",
    descripcion: "Formulación, implementación y seguimiento de iniciativas sociales con evidencias fotográficas y trazabilidad completa.",
    puntosClave: ["Máquina de estados por iniciativa", "Galería de evidencias por actividad", "Tracker de compromisos comunitarios"],
    stack: ["Motor de captura dinámica", "Repositorio Cloud"],
    imagen: "https://images.unsplash.com/photo-1552664730-d307ca884978?w=800&q=80&auto=format&fit=crop",
    status: "reutilizar",
    url: "",
  },
  {
    id: 8,
    grupo: "B",
    nombre: "Prevención y Diálogo Social",
    descripcion: "Sistema de alertas tempranas con SLA, espacios de diálogo y seguimiento de acuerdos en mesas territoriales.",
    puntosClave: ["Alertas SLA nivel 1/2/3", "Mapa de calor de conflictividad", "Registro de acuerdos comunitarios"],
    stack: ["Tablero de Indicadores", "Workflows de Alertas"],
    imagen: "https://images.unsplash.com/photo-1517048676732-d65bc937f952?w=800&q=80&auto=format&fit=crop",
    status: "adaptar",
    url: "",
  },
  {
    id: 9,
    grupo: "B",
    nombre: "Formulación de Proyectos (Marco Lógico)",
    descripcion: "Diseño estructurado de proyectos bajo metodología MGA-DNP: árbol de problemas, matriz marco lógico y Gantt automático.",
    puntosClave: ["Árbol de problemas/objetivos", "Matriz marco lógico MGA-DNP", "Gantt automático desde actividades"],
    stack: ["Motor de captura dinámica", "Modelado de Proyectos"],
    imagen: "https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?w=800&q=80&auto=format&fit=crop",
    status: "nuevo",
    url: "",
  },

  // ─── GRUPO C: Formación y Desarrollo ─────────────────────────
  {
    id: 10,
    grupo: "C",
    nombre: "Campus Virtual — Beneficiarios",
    descripcion: "Rutas de aprendizaje modulares en emprendimiento y exportación con certificación automática al completar.",
    puntosClave: ["Rutas por perfil productivo", "Certificado PDF con QR", "Dashboard de avance por región"],
    stack: ["LMS Corporativo", "Certificación Automatizada"],
    imagen: "https://images.unsplash.com/photo-1522202176988-66273c2fd55f?w=800&q=80&auto=format&fit=crop",
    status: "adaptar",
    url: "",
  },
  {
    id: 11,
    grupo: "C",
    nombre: "Campus Virtual — Comunidades",
    descripcion: "Formación en derechos, participación y transición energética con material diferenciado por etnia y lengua.",
    puntosClave: ["Catálogo diferenciado étnico", "Modo offline para zonas rurales", "Tracker de acceso por comunidad"],
    stack: ["LMS Corporativo", "E-learning Diferencial"],
    imagen: "https://images.unsplash.com/photo-1529156069898-49953e39b3ac?w=800&q=80&auto=format&fit=crop",
    status: "nuevo",
    url: "",
  },
  {
    id: 12,
    grupo: "C",
    nombre: "Campus Virtual — Personal Convenio",
    descripcion: "Inducción obligatoria y certificación HSE para todo el personal del proyecto (obligación contractual del convenio).",
    puntosClave: ["Ruta de inducción obligatoria", "Certificación HSE con vigencia", "Bloqueo automático si HSE vencido"],
    stack: ["LMS Corporativo", "E-learning"],
    imagen: "https://images.unsplash.com/photo-1571260899304-425eee4c7efc?w=800&q=80&auto=format&fit=crop",
    status: "adaptar",
    url: "",
  },
  {
    id: 13,
    grupo: "C",
    nombre: "Aceleradora Exportadora",
    descripcion: "Pipeline Kanban para las fases 4–9 FWRTS: puntaje, trámites, maquinaria, planes de negocio y ferias internacionales.",
    puntosClave: ["Pipeline Kanban fases FWRTS", "Puntaje automático de elegibilidad", "Postulación a ferias internacionales"],
    stack: ["Workflows", "Pipeline de Negocios"],
    imagen: "https://images.unsplash.com/photo-1507537297725-24a1974df4df?w=800&q=80&auto=format&fit=crop",
    status: "nuevo",
    url: "",
  },

  // ─── GRUPO D: Actores y Talento Humano ───────────────────────
  {
    id: 14,
    grupo: "D",
    nombre: "Padrón de Beneficiarios",
    descripcion: "Registro maestro con consentimientos Habeas Data, segmentación por perfil/etnia y tarjetas QR de identificación para los 10.000+ beneficiarios del convenio.",
    puntosClave: ["Deduplicación automática por cédula", "Ficha 360 con consentimiento Habeas Data", "Tarjeta QR digital por beneficiario"],
    stack: ["Motor de captura dinámica", "Identidad Digital QR"],
    imagen: "https://images.unsplash.com/photo-1521737604893-d14cc237f11d?w=800&q=80&auto=format&fit=crop",
    status: "reutilizar",
    url: "",
  },
  {
    id: 15,
    grupo: "D",
    nombre: "CRM de Actores (Directorio)",
    descripcion: "Directorio integral de operadoras, comunidades, autoridades y gremios con historial cronológico de interacciones y semáforo de relacionamiento por actor.",
    puntosClave: ["Timeline de interacciones por actor", "Semáforo de relacionamiento automático", "Red de relaciones por región"],
    stack: ["Tablero de Indicadores", "CRM Territorial"],
    imagen: "https://images.unsplash.com/photo-1542744173-8e7e53415bb0?w=800&q=80&auto=format&fit=crop",
    status: "nuevo",
    url: "",
  },
  {
    id: 16,
    grupo: "D",
    nombre: "Consulta Previa",
    descripcion: "Seguimiento de procesos CIPRUNNA por resguardo/cabildo con máquina de estados, formularios adaptativos por etnia y repositorio de acuerdos firmados.",
    puntosClave: ["Máquina de estados 7 etapas CIPRUNNA", "Formulario adaptativo por etnia/lengua", "Alerta automática por etapa vencida"],
    stack: ["Repositorio Cloud Cifrado", "Workflows"],
    imagen: "https://images.unsplash.com/photo-1529156069898-49953e39b3ac?w=800&q=80&auto=format&fit=crop",
    status: "nuevo",
    url: "",
  },
  {
    id: 17,
    grupo: "D",
    nombre: "Reclutamiento y Selección",
    descripcion: "Pipeline de selección con scoring automático ponderado, matriz de calificación editable por evaluador y generación de informe final del proceso para la entidad contratante.",
    puntosClave: ["Scoring automático con pesos configurables", "Pipeline Kanban 4 etapas", "Informe del proceso descargable PDF"],
    stack: ["Workflows de Aprobación", "Scoring Automatizado"],
    imagen: "https://images.unsplash.com/photo-1565688534245-05d6b5be184a?w=800&q=80&auto=format&fit=crop",
    status: "nuevo",
    url: "",
  },
  {
    id: 18,
    grupo: "D",
    nombre: "Administración de Personal",
    descripcion: "Gestión de planta vinculada con verificación de seguridad social, registro de novedades, alertas de vencimiento y reporte de nómina por desembolso del convenio.",
    puntosClave: ["Alertas SS 30/15/7 días antes", "Reporte nómina por desembolso", "Dashboard planta activa por región"],
    stack: ["Data Grid Cloud", "Alertas de Vencimiento"],
    imagen: "https://images.unsplash.com/photo-1521737604893-d14cc237f11d?w=800&q=80&auto=format&fit=crop",
    status: "adaptar",
    url: "",
  },
  {
    id: 19,
    grupo: "D",
    nombre: "Gestión de Alianzas",
    descripcion: "Seguimiento de CARs en 8 regiones y entidades nacionales con tracker de productos comprometidos, semáforo de alianza y alerta por 21 días sin reporte.",
    puntosClave: ["Dashboard por CAR y región", "Tracker de productos comprometidos", "Alerta automática 21 días sin reporte"],
    stack: ["Tablero de Indicadores", "Dashboard de Convenios"],
    imagen: "https://images.unsplash.com/photo-1450101499163-c8848c66ca85?w=800&q=80&auto=format&fit=crop",
    status: "nuevo",
    url: "",
  },

  // ─── GRUPO E: Finanzas y Gobernanza ──────────────────────────
  {
    id: 20,
    grupo: "E",
    nombre: "Seguridad y Accesos",
    descripcion: "Sistema RBAC con matriz rol × módulo × permiso, MFA obligatorio para roles financieros, log de auditoría inmutable y portal Habeas Data.",
    puntosClave: ["RBAC con 6 roles definidos", "MFA obligatorio roles financieros", "Log de auditoría inmutable con IP"],
    stack: ["Microservicios Serverless", "Control MFA"],
    imagen: "https://images.unsplash.com/photo-1563986768494-4dee2763ff3f?w=800&q=80&auto=format&fit=crop",
    status: "reutilizar",
    url: "",
  },
  {
    id: 21,
    grupo: "E",
    nombre: "Monitoreo Plan Operativo",
    descripcion: "Dashboard ejecutivo de 1 página con 6 KPIs críticos, línea de tiempo de 4 desembolsos del proyecto y exportación mensual automática en PDF.",
    puntosClave: ["Dashboard ejecutivo 1 página", "Línea de tiempo desembolsos 35/50/70/100%", "Exportación PDF automática mensual"],
    stack: ["Tablero de Indicadores", "Hitos Estratégicos"],
    imagen: "https://images.unsplash.com/photo-1611974789855-9c2a0a7236a3?w=800&q=80&auto=format&fit=crop",
    status: "reutilizar",
    url: "",
  },
  {
    id: 22,
    grupo: "E",
    nombre: "Gestión Financiera",
    descripcion: "Control de ejecución presupuestal en 3 ítems (Personal/Operación/Inversión) + contrapartida con proyección de cierre y alertas de sobre-ejecución.",
    puntosClave: ["3 ítems + contrapartida con proyección", "Alertas al 80% y 95% de ejecución", "Dashboard Looker con drill-down"],
    stack: ["Data Grid Cloud", "Proyección Presupuestal"],
    imagen: "https://images.unsplash.com/photo-1554224155-6726b3ff858f?w=800&q=80&auto=format&fit=crop",
    status: "nuevo",
    url: "",
  },
  {
    id: 23,
    grupo: "E",
    nombre: "Cuentas de Cobro",
    descripcion: "Radicación mensual con validación automática de SS, countdown de 5 días hábiles y bloqueo si el informe del funcionario no está aprobado en Módulo 27.",
    puntosClave: ["Validación automática SS al radicar", "Countdown 5 días hábiles Colombia", "Bloqueo por informe no aprobado M27"],
    stack: ["Workflows", "Validación Serverless"],
    imagen: "https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?w=800&q=80&auto=format&fit=crop",
    status: "nuevo",
    url: "",
  },
  {
    id: 24,
    grupo: "E",
    nombre: "Secretaría de Comité",
    descripcion: "Gestión de sesiones del comité directivo con plantilla de actas numeradas automáticamente, tracker de compromisos y flujo de aprobación de subcontratos.",
    puntosClave: ["Actas numeradas automáticamente", "Recordatorio 5 días antes de sesión", "Tracker de compromisos con semáforo"],
    stack: ["Repositorio Cloud Cifrado", "Gestión de Actas"],
    imagen: "https://images.unsplash.com/photo-1552664730-d307ca884978?w=800&q=80&auto=format&fit=crop",
    status: "nuevo",
    url: "",
  },
  {
    id: 25,
    grupo: "E",
    nombre: "Adquisiciones ESAL",
    descripcion: "Pipeline Kanban de 6 estados para subcontratos con biblioteca de minutas tipo, validaciones previas y alerta por 10 días sin aprobación de comité.",
    puntosClave: ["Pipeline Kanban 6 estados ESAL", "Biblioteca minutas tipo (servicio/suministro)", "Reporte de adquisiciones por desembolso"],
    stack: ["Pipeline de Compras", "Biblioteca de Minutas"],
    imagen: "https://images.unsplash.com/photo-1450101499163-c8848c66ca85?w=800&q=80&auto=format&fit=crop",
    status: "nuevo",
    url: "",
  },
  {
    id: 26,
    grupo: "E",
    nombre: "Matriz de Riesgos",
    descripcion: "Matriz CONPES 3714 con puntaje automático probabilidad × impacto, mapa de calor, planes de mitigación y trigger automático al Módulo 21 ante materialización.",
    puntosClave: ["Matriz calor CONPES 3714", "Puntaje automático probabilidad × impacto", "Trigger a M21 ante materialización"],
    stack: ["Mapa de Calor de Riesgos", "Planes de Mitigación"],
    imagen: "https://images.unsplash.com/photo-1611974789855-9c2a0a7236a3?w=800&q=80&auto=format&fit=crop",
    status: "nuevo",
    url: "",
  },

  // ─── GRUPO F: Informes ────────────────────────────────────────
  {
    id: 27,
    grupo: "F",
    nombre: "Revisión de Informes",
    descripcion: "Flujo de radicación → revisión → aprobación de informes por funcionario. Sin informe aprobado se bloquea la cuenta de cobro en Módulo 23.",
    puntosClave: ["Máquina de estados 4 fases", "Bloqueo automático cuenta cobro M23", "Dashboard de cumplimiento por período"],
    stack: ["Workflows de Aprobación", "Control de Versiones"],
    imagen: "https://images.unsplash.com/photo-1568234928966-359c35dd8327?w=800&q=80&auto=format&fit=crop",
    status: "nuevo",
    url: "",
  },
  {
    id: 28,
    grupo: "F",
    nombre: "Compilador de Informes",
    descripcion: "Compilador automático que jala datos de 6 módulos para generar los informes de los 4 desembolsos del proyecto (D1/D2/D3/D4) con control de versiones y exportación PDF.",
    puntosClave: ["Compilación automática desde 6 módulos", "Control de versiones con autor y fecha", "Validación de completitud por sección"],
    stack: ["Automatización Documental", "Serverless"],
    imagen: "https://images.unsplash.com/photo-1507842217343-583bb7270b66?w=800&q=80&auto=format&fit=crop",
    status: "nuevo",
    url: "",
  },
  {
    id: 29,
    grupo: "F",
    nombre: "Gestión del Conocimiento",
    descripcion: "Repositorio de metodologías, casos de éxito y buenas prácticas con votación, buscador por etiquetas y distribución automática entre formadores Moodle.",
    puntosClave: ["Buscador con filtros múltiples", "Sistema de votación y ranking", "Distribución automática en Moodle M11"],
    stack: ["Repositorio de Casos de Éxito", "Banco de Herramientas"],
    imagen: "https://images.unsplash.com/photo-1522202176988-66273c2fd55f?w=800&q=80&auto=format&fit=crop",
    status: "reutilizar",
    url: "",
  },

  // ─── GRUPO G: Operación y Logística ──────────────────────────
  {
    id: 30,
    grupo: "G",
    nombre: "Agenda Territorial",
    descripcion: "Planificación de talleres, foros y ferias con convocatoria automática, registro de asistencia por QR y seguimiento de compromisos post-evento.",
    puntosClave: ["Registro asistencia QR por evento", "Convocatoria masiva email/WhatsApp", "Tracker compromisos con semáforo"],
    stack: ["Calendario Cloud", "Asistencia QR"],
    imagen: "https://images.unsplash.com/photo-1511795409834-ef04bbd61622?w=800&q=80&auto=format&fit=crop",
    status: "nuevo",
    url: "",
  },
  {
    id: 31,
    grupo: "G",
    nombre: "Gestión Logística",
    descripcion: "Checklist logístico por evento con cotizaciones por rubro, calculadora de costos y validación de disponibilidad presupuestal antes de aprobar.",
    puntosClave: ["Checklist por rubro (transporte/aloj/alim)", "Calculadora de costos con cotizaciones", "Bloqueo si rubro sin soporte documental"],
    stack: ["Calculadora de Costos", "Control de Rubros"],
    imagen: "https://images.unsplash.com/photo-1519751138087-5bf79df62d5f?w=800&q=80&auto=format&fit=crop",
    status: "nuevo",
    url: "",
  },
  {
    id: 32,
    grupo: "G",
    nombre: "Visibilidad y Prensa",
    descripcion: "Biblioteca de piezas digitales por iniciativa con checklist de visibilidad obligatorio, dashboard de métricas de alcance y generador de casos de éxito.",
    puntosClave: ["Biblioteca de activos con versionado", "Dashboard métricas por canal digital", "Generador de casos de éxito (antes/después)"],
    stack: ["Biblioteca de Activos Digitales", "Métricas de Impacto"],
    imagen: "https://images.unsplash.com/photo-1560472354-b33ff0c44a43?w=800&q=80&auto=format&fit=crop",
    status: "nuevo",
    url: "",
  },
  {
    id: 33,
    grupo: "G",
    nombre: "HSE y Emergencias",
    descripcion: "Reporte de incidentes mobile-first en 3 pasos, tracker de EPP por funcionario, protocolos por zona y verificación de certificación HSE contra Módulo 12.",
    puntosClave: ["Reporte incidentes 3 pasos móvil-first", "Tracker EPP con vigencia 6 meses", "Bloqueo campo si EPP vencido"],
    stack: ["Reporte Móvil de Incidentes", "Notificaciones Serverless"],
    imagen: "https://images.unsplash.com/photo-1578662996442-48f60103fc96?w=800&q=80&auto=format&fit=crop",
    status: "nuevo",
    url: "",
  },

  // ─── GRUPO H: Soporte y Documentación ────────────────────────
  {
    id: 34,
    grupo: "H",
    nombre: "Gestión Documental IA",
    descripcion: "Repositorio jerárquico Convenio→Región→Municipio→Componente con nomenclatura automática, clasificación Gemini AI, alertas de vencimiento y reporte de completitud.",
    puntosClave: ["Nomenclatura automática al subir", "Clasificación IA Gemini por metadatos", "Alertas vencimiento contratos/pólizas"],
    stack: ["Almacenamiento Cloud", "IA Generativa (NLP)"],
    imagen: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=800&q=80&auto=format&fit=crop",
    status: "reutilizar",
    url: "",
  },
  {
    id: 35,
    grupo: "H",
    nombre: "Control de Inventarios",
    descripcion: "Trazabilidad de bienes con QR único por bien, actas de entrega automáticas y alerta por bienes sin ubicación en 30 días.",
    puntosClave: ["QR único por bien", "Acta de entrega PDF con firma digital", "Alerta bienes sin ubicación en 30 días"],
    stack: ["Escaneo QR", "Trazabilidad de Activos"],
    imagen: "https://images.unsplash.com/photo-1586864387967-d02ef85d93e8?w=800&q=80&auto=format&fit=crop",
    status: "adaptar",
    url: "",
  },
  {
    id: 36,
    grupo: "H",
    nombre: "Monitor de Pólizas",
    descripcion: "Semáforo de 3 niveles para pólizas de cumplimiento/calidad/salarios con alertas escalonadas 60/30/15 días y bloqueo automático de desembolso si póliza vencida.",
    puntosClave: ["Semáforo 3 niveles (verde>60d, rojo<30d)", "Alertas escalonadas 60/30/15 días", "Bloqueo desembolso M22 si vencida"],
    stack: ["Semáforo de Vigencias", "Workflows de Renovación"],
    imagen: "https://images.unsplash.com/photo-1568234928966-359c35dd8327?w=800&q=80&auto=format&fit=crop",
    status: "nuevo",
    url: "",
  },
  {
    id: 37,
    grupo: "H",
    nombre: "Liquidación y Cierre",
    descripcion: "Checklist interactivo de los 39 módulos con requisitos de cierre, acta de liquidación automática y control de paz y salvos de entidades aliadas.",
    puntosClave: ["Checklist interactivo 39 módulos", "Bloqueo cierre sin paz y salvos completos", "Acta de liquidación con balance final"],
    stack: ["Checklist Transversal", "Actas Automáticas"],
    imagen: "https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?w=800&q=80&auto=format&fit=crop",
    status: "nuevo",
    url: "",
  },

  // ─── GRUPO I: Infraestructura ─────────────────────────────────
  {
    id: 38,
    grupo: "I",
    nombre: "Mesa de Ayuda",
    descripcion: "Sistema de tickets con SLA (crítico 2h, alto 8h, medio 24h), base de conocimiento por rol y escalamiento automático ante vencimiento.",
    puntosClave: ["SLA crítico 2h / alto 8h / medio 24h", "Base de conocimiento filtrada por rol", "Escalamiento automático ante vencimiento"],
    stack: ["Helpdesk Cloud", "Gestión de SLA"],
    imagen: "https://images.unsplash.com/photo-1588196749597-9ff075ee6b5b?w=800&q=80&auto=format&fit=crop",
    status: "reutilizar",
    url: "",
  },
  {
    id: 39,
    grupo: "I",
    nombre: "Continuidad Tecnológica",
    descripcion: "Dashboard de infraestructura con monitor de disponibilidad 99.5%, backups diarios automáticos con retención de 24 meses y plan de contingencia activable.",
    puntosClave: ["Monitor disponibilidad 99.5% SLA", "Backups diarios retención 24 meses", "Plan de contingencia activable"],
    stack: ["Infraestructura Cloud", "Backups Automatizados"],
    imagen: "https://images.unsplash.com/photo-1558494949-ef010cbdcc31?w=800&q=80&auto=format&fit=crop",
    status: "adaptar",
    url: "",
  },

];
